import placementService from 'ApiService/Admin/placementService';
import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useFormKeyboardSubmit } from 'pages/Hooks/useStepperKeyboardNavigation';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import AddHrInfo from './Steps/AddHrInfo';
import ConfirmationModal from 'pages/Common/ConfirmationModal';

const Index = () => {
  const { state } = useContext(AuthContext);
  const isSuperAdmin = state?.user?.role === 'superadmin';
  const selectedBranch = state?.selectedBranch || '';

  const [placementData, setPlacementData] = useState({
    placementName: '',
    placementEmail: '',
    placementPassword: '',
    contactNumber: '',
    hrRole: 'hr',
    allPermission: false,
    branches: isSuperAdmin ? [] : selectedBranch ? [selectedBranch] : [],
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (
      !placementData.placementName &&
      !placementData.placementEmail &&
      !placementData.placementPassword &&
      !placementData.contactNumber
    ) {
      toast.error('All fields are required.');
    }
    setIsModalOpen(true);
  };

  const confirmCreation = async () => {
    setLoading(true);
    setIsModalOpen(false);

    try {
      const trimmedData = {
        placementName: placementData.placementName?.trim().replace(/\s+/g, ' '),
        placementEmail: placementData.placementEmail
          ?.trim()
          .replace(/\s+/g, ' '),
        placementPassword: placementData.placementPassword
          ?.trim()
          .replace(/\s+/g, ' '),
        contactNumber: placementData.contactNumber?.trim().replace(/\s+/g, ' '),
        hrRole: placementData.hrRole || 'hr',
        allPermission: placementData.allPermission || false,
        branches: placementData.branches || [],
      };
      const response = await placementService.createPlacementOfficer({
        ...trimmedData,
        selectedBranch:
          placementData.hrRole === 'headhr' ||
          (placementData.hrRole === 'jrhr' && placementData.allPermission)
            ? undefined
            : selectedBranch,
      });
      if (response.data.success) {
        setPlacementData({
          placementName: '',
          placementEmail: '',
          placementPassword: '',
          contactNumber: '',
          hrRole: 'hr',
          allPermission: false,
          branches: [],
        });
        toast.success(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useFormKeyboardSubmit(handleSubmit, disable, loading);

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
        <Card extra=" -mt-[280px] w-full md:-mt-[240px] md:px-[70px] h-full mx-auto pb-3">
          <div className="rounded-[20px]">
            <AddHrInfo
              setPlacementData={setPlacementData}
              placementData={placementData}
              disable={disable}
              setDisable={setDisable}
            />
          </div>
          <div className="mt-4 flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
            <button
              disabled={disable}
              onClick={handleSubmit}
              className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
            >
              {loading ? 'Loading..' : 'Submit'}
            </button>
          </div>
        </Card>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={confirmCreation}
        title="Create HR Confirmation"
        message={`Are you sure you want to create ${
          placementData.placementName
        } as a ${
          placementData.hrRole === 'headhr'
            ? 'Head HR'
            : placementData.hrRole === 'jrhr'
            ? 'JR HR'
            : 'HR'
        } user?`}
        confirmText="Yes, Create"
        cancelText="Cancel"
        icon="info"
      />
    </div>
  );
};

export default Index;
